module.exports = __webpack_public_path__ + "static/media/Metal.67f208a2.svg";